import { api } from "../config";

// Common API
export const UPDATE_COLUMN_PREFRENCE = "/UpdateColumnPreference";


//REGISTER
export const POST_REGISTER = "/Signup";

//LOGIN
export const POST_LOGIN = "/Login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FORGOTPWD = "/ResetUrlSent";
export const POST_RESET_PASSWORD = "/ResetPassword"; // New endpoint for performing the reset
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//Localization
export const GET_LOCALIZATION = "/GetLocalization";
export const POST_LOCALIZATION = "/AddLocalization";
export const UPDATE_LOCALIZATION = "/UpdateLocalization";
export const DELETE_LOCALIZATION = "/DeleteLocalization";
export const GET_SCREENS = "/GetScreens";
export const GET_LOCALIZATION_TABLE_COLUMN_NAMES = "/GetHeaders";
export const POST_SCREENS = "/AddScreen";
export const UPDATE_SCREENS = "/UpdateScreen";
export const DELETE_SCREENS = "/DeleteScreen";

//Logs
export const GET_LOGS = "/Getlogs";

//Country
export const GET_COUNTRY_ALL = "/GetCountryAll";
export const UPDATE_COUNTRY = "/UpdateCountry";
export const GET_ACTIVE_DEACTIVE_COUNTRY = "/ActivateDeactivateCountry";

//Topics
export const GET_TOPICS_ALL = "/GetAllTopics";
export const ADD_TOPICS = "/AddTopics";
export const UPDATE_TOPICS = "/UpdateTopics";
export const DELETE_TOPICS = "/DeleteTopics";
export const GET_ACTIVE_DEACTIVE_TOPICS = "/ActivateDeactivateTopics";

//Sub Topics
export const GET_SUB_TOPICS_ALL = "/GetAllSubTopics";
export const ADD_SUB_TOPICS = "/AddSubTopics";
export const UPDATE_SUB_TOPICS = "/UpdateSubTopics";
export const DELETE_SUB_TOPICS = "/DeleteSubTopics";
export const GET_ACTIVE_DEACTIVE_SUB_TOPICS = "/ActivateDeactivateSubTopics";


//Roles
export const GET_All_ROLES = "/GetAllRoles";
export const GET_ROLES = "/GetRoles";
export const POST_ROLE = "/AddRoles";
export const UPDATE_ROLE = "/UpdateRole";
export const DELETE_ROLE = "/DeleteRole";
export const ACTIVE_ROLE = "/ActivateDeactiveRole";
export const GET_All_PAGES = "/GetAllPages";
export const UPDATE_PAGE_PERMISSION = "/UpdatePagePermission";
export const GET_USER_MODULE = "/GetUserModules";

// Category
export const GET_All_CATEGORIES = "/GetAllCategories";
export const GET_DOCUMENTS_TYPE = "/GetDocumentsType";
export const GET_All_PARENT_CATEGORIES = "/GetParentCategories";
export const POST_CATEGORY = "/AddCategory";
export const UPDATE_CATEGORY = "/UpdateCategory";
export const ACTIVE_CATEGORY = "/ActivateDeactiveCategory";
export const DELETE_CATEGORY = "/DeleteCategory";

//Tags
export const GET_All_TAGS = "/GetAllTags";
export const ADD_TAG = "/addTag";

//Users
export const GET_USERS = "/GetUsers";
export const GET_BRANCHES = "/GetBranches";
export const GET_GENDERS = "/GetGenders";
export const GET_COUNTRY = "/GetCountry";
export const GET_USER_BY_ID = "/GetUserById";
export const UPDATE_USER_PROFILE = "/UpdateUserProfile";
export const ADD_USER = "/AddUser";
export const CHECK_USER_EXISTENCE = "/CheckUserExistence";
export const UPDATE_USER = "/UpdateUser";
export const UpdateUserRole = "/UpdateUserRole";
export const TOGGLE_USER = "/ToggleStatus";
export const DELETE_USER = "/DeleteUser";
export const ACTIVATE_DELETE_USER = "/ActivateDeleteUser";

// AI Chat
// export const STREAMING_AI_RESPONSE = `https://prod-dot-alitqan-fa631.el.r.appspot.com/api/rag/query`;
// export const STREAMING_CASE_AI_RESPONSE = `https://prod-dot-alitqan-fa631.el.r.appspot.com/api/case-rag/query`;

// export const STREAMING_AI_RESPONSE = `https://rag.api.alitqan.ai/api/rag/query`;
// export const STREAMING_CASE_AI_RESPONSE = `https://rag.api.alitqan.ai/api/case-rag/query`;

// export const STREAMING_AI_RESPONSE = `https://socket.yasalab.com/api/rag/query`;
// export const STREAMING_CASE_AI_RESPONSE = `https://socket.yasalab.com/api/case-rag/query`;

export const STREAMING_AI_RESPONSE = `${api.STREAMING_URL}/api/rag/query`;
export const STREAMING_CASE_AI_RESPONSE = `${api.STREAMING_URL}/api/case-rag/query`;
export const ADD_AI_RESPONSE = "/AddAIResponse";
export const GET_CHAT_SESSION_HISTORY = "/GetChatSessionHistory";
export const GET_CHAT_HISTORY = "/GetChatHistory";
export const LIKE_DISLIKE_MESSAGE = "/LikeDislikeMessage";
export const EDIT_CHAT_SESSION_TITLE = "/EditChatSessionTitle";
export const DELETE_CHAT_SESSION = "/DeleteChatSession";


// AI Document
export const GET_DOCUMENTS = "/api/GetAllDocuments"; 
export const ADD_DOCUMENT_METADATA = "/AddDocument"; 
export const ADD_CORE_DOCUMENT_METADATA = "/AddCoreDocument";
export const RETRY_DOCUMENT = "/RetryDocument";
export const MERGE_DOCUMENT_JSON = `${api.STREAMING_URL}/api/rag/MergeJson`;
export const REMOVE_DOCUMENTS = "/DeleteDocument"; 
export const REVIEWED_DOCUMENT = "/ReviewedDocument";
export const GET_All_SUB_CATEGORIES = "/GetSubCategories"; 
export const UPLOAD_DOC_DETAILS = "/AddDocDetails";
export const UPDATE_DOCUMENT = "/UpdateDocument";
export const UPDATE_DOCUMENT_JSON_URL = "/UpdateDocumentJsonURL";
export const SAVE_DOC_DETAILS = `${api.STREAMING_URL}/api/rag/SaveEmbedding`;
export const GET_CHUNK_DATA = "/GetChunkData";

// Cases
export const GET_CASES = "/api/GetAllCases"; 
export const ADD_CASE = "/AddCase"; 
export const UPDATE_CASE = "/UpdateCase";
export const UPDATE_CASE_JSON_URL = "/UpdateCaseJsonURL";
export const REMOVE_CASES = "/DeleteCase"; 
export const REVIEWED_CASE = "/ReviewedCase";
export const SAVE_CASE_DETAILS = `${api.STREAMING_URL}/api/rag/CasesSaveEmbedding`;
export const GET_CASE_TYPES = "/GetAllCaseTypes"; 
export const GET_CASE_CHUNKS = "/GetCaseChunks";

// AI Prompt
export const GET_All_PROMPTS = "/GetPrompts";
export const SAVE_OR_UPDATE_PROMPT = "/AddOrEditPrompt";

// Human categories
export const GET_HUMAN_CATEGORIES = "/GetHumanCategories";
export const ADD_HUMAN_CATEGORIES = "/AddHumanCategory";
export const UPDATE_HUMAN_CATEGORIES = "/UpdateHumanCategory";
export const DELETE_HUMAN_CATEGORIES = "/DeleteHumanCategory";
export const ACTIVATE_DEACTIVATE_HUMAN_CATEGORIES = "/ActivateDeactivateHumanCategory";

// Chat Report
export const GET_CHAT_REPORT = "/GetHumanServiceReports";
export const GET_CLIENT_USERS = "/GetUsers";
export const GET_HUMAN_SERVICE_CHATS = "/GetHumanServiceChats";

// AI Chat Report
export const GET_AI_CHAT_REPORT = "/GetAIChatReports";
export const GET_AI_CHATS = "/GetAIChats";
export const UPDATE_CHAT_FEEDBACK_STATUS = "/UpdateChatFeedbackStatus";
export const DELETE_AI_CHAT_REPORT = "/DeleteAIChatReport";

// User Reported Issue 
export const GET_USER_REPORTED_ISSUES = "/GetUserReportedIssues";
export const GET_USER_REPORTED_ISSUES_CHATS = "/GetReportedAIChats";
export const UPDATE_USER_REPORTED_ISSUE_STATUS = "/UpdateChatReportedIssueStatus";
export const DELETE_USER_REPORTED_ISSUES = "/DeleteReportedIssue";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const DELETE_PRODUCT = "/apps/product";
export const ADD_NEW_PRODUCT = "/apps/product";
export const UPDATE_PRODUCT = "/apps/product";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/apps/ticket";
export const ADD_NEW_TICKET = "/apps/ticket";
export const UPDATE_TICKET = "/apps/ticket";
export const DELETE_TICKET = "/apps/ticket";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA = "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";
export const GET_DASHBOARD_DATA = "/GetDashboardData";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// COMMON
export const GET_DAYS = "/GetDays";
export const GET_TRANSLATION = '/TranslateText'
export const GET_QUESTION_TYPES = "/GetQuestionTypes";
export const GET_DIFFICULTY_LEVEL = "/GetDifficultyLevel";
export const GET_USER_BY_ROLEID = "/GetUsersByRoleID";

export const GET_COMMON_LABELS = "/GetCommonLabels";
export const POST_COMMON_LABELS = "/AddCommonLabels";
export const UPDATE_COMMON_LABELS = "/UpdateCommonLabels";
export const DELETE_COMMON_LABELS = "/DeleteCommonLabels";
export const ACTIVATE_DEACTIVATE_COMMON_LABELS = "/ActivateDeactivateCommonLabels";

export const GET_HEADERS = "/GetHeaders";
export const UPLOAD_IMAGES = "/UploadImages";
export const UPLOAD_DOC = `${api.STREAMING_URL}/api/rag/full-pipeline`;
export const RETRY_DOC = `${api.STREAMING_URL}/api/rag/NewJson`;
export const UPLOAD_CASE = `${api.STREAMING_URL}/api/rag/cases-full-pipeline`;
export const JSON_CASE = `${api.STREAMING_URL}/api/rag/CasesJson`;
// COURSES
export const GET_COURSES = "/GetCourses";
export const POST_COURSES = "/AddCourses";
export const UPDATE_COURSES = "/UpdateCourses";
export const DELETE_COURSES = "/DeleteCourses";
export const ACTIVATE_DEACTIVATE_COURSES = "/ActivateDeactivateCourses";

// COURSE MODULE
export const GET_COURSE_MODULES = "/GetCourseModules";
export const POST_COURSE_MODULES = "/AddCourseModules";
export const UPDATE_COURSE_MODULES = "/UpdateCourseModules";
export const DELETE_COURSE_MODULES = "/DeleteCourseModules";
export const TOGGLE_COURSE_MODULES = "/ActivateDeactivateCoursesModule";

// COURSE SESSION
export const GET_COURSE_SESSIONS = "/GetCourseSessions";
export const POST_COURSE_SESSIONS = "/AddCourseSessions";
export const UPDATE_COURSE_SESSIONS = "/UpdateCourseSessions";
export const DELETE_COURSE_SESSIONS = "/DeleteCourseSessions";
export const CANCEL_COURSE_SESSIONS = "/CancelCourseSession";
export const POST_ASSIGNMENT_QUESTIONS = "/AddAssignmentQuestions";
export const DELETE_ASSIGNMENT_QUESTIONS = "/DeleteAssignmentQuestions";
export const POST_ADDISTIONAL_ASSIGNMENT_QUESTIONS = "/AddAdditionalAssignmentQuestions";
export const DELETE_ADDISTIONAL_ASSIGNMENT_QUESTIONS = "/DeleteAdditionalAssignmentQuestions";

// ENROLL STUDENTS
export const GET_ENROLL_STUDENTS = "/GetEnrollStudents";
export const POST_ENROLL_STUDENTS = "/AddEnrollStudents";
export const UPDATE_ENROLL_STUDENTS = "/UpdateEnrollStudents";
export const DELETE_ENROLL_STUDENTS = "/DeleteEnrollStudents";
export const UPDATE_ENROLL_STUDENTS_COURSE_PAYMENT = "/UpdateStudentCoursePayment";

// REFERRAL REWARD
export const GET_REFERRAL_REWARD = "/GetReferralReward";
export const POST_REFERRAL_REWARD = "/AddReferralReward";
export const UPDATE_REFERRAL_REWARD = "/UpdateReferralReward";
export const DELETE_REFERRAL_REWARD = "/DeleteReferralReward";
export const ACTIVATE_DEACTIVATE_REFERRAL_REWARD = "/ActivateDeactivateReferralReward";

// REFERRAL Earn
export const GET_REFERRAL_EARN = "/GetReferredUsers";
export const GET_REFERRAL_STATUS = "/GetReferralStatus";
export const UPDATE_REFERRAL = "/UpdateReferral";
// export const POST_REFERRAL_REWARD = "/AddReferralReward";
// export const UPDATE_REFERRAL_REWARD = "/UpdateReferralReward";
// export const DELETE_REFERRAL_REWARD = "/DeleteReferralReward";
// export const ACTIVATE_DEACTIVATE_REFERRAL_REWARD = "/ActivateDeactivateReferralReward";

// QUESTIONS
export const GET_QUESTIONS = "/GetAssignmentQuestions";
export const POST_QUESTIONS = "/AddQuestions";
export const UPDATE_QUESTIONS = "/UpdateQuestions";
export const DELETE_QUESTIONS = "/DeleteQuestions";
export const ACTIVATE_DEACTIVATE_QUESTIONS = "/ActivateDeactivateQuestions";
export const QUESTION_OPTIONS = "/QuestionOptions";
export const GET_SCORE = "/GetScores";

// QUESTION OPTIONS
export const GET_QUESTION_OPTIONS = "/GetQuestionOptions";
export const POST_QUESTION_OPTIONS = "/AddQuestionOptions";
export const UPDATE_QUESTION_OPTIONS = "/UpdateQuestionOptions";
export const DELETE_QUESTION_OPTIONS = "/DeleteQuestionOptions";

// QUESTIONS
export const GET_QUESTION_HINTS = "/GetQuestionHints";
export const POST_QUESTION_HINTS = "/AddQuestionHints";
export const UPDATE_QUESTION_HINTS = "/UpdateQuestionHints";
export const DELETE_QUESTION_HINTS = "/DeleteQuestionHints";

// QUESTION CATEGORY
export const GET_QUESTION_CATEGORY = "/GetQuestionCategory";
export const POST_QUESTION_CATEGORY = "/AddQuestionCategory";
export const UPDATE_QUESTION_CATEGORY = "/UpdateQuestionCategory";
export const DELETE_QUESTION_CATEGORY = "/DeleteQuestionCategory";
export const ACTIVATE_DEACTIVATE_QUESTION_CATEGORY = "/ActivateDeactivateQuestionCategory";

// QUESTION ATTEMPTS
export const GET_QUESTION_ATTEMPTS = "/GetAttemptScore";
export const POST_QUESTION_ATTEMPTS = "/AddAttemptScore";
export const UPDATE_QUESTION_ATTEMPTS = "/UpdateAttemptScore";
export const DELETE_QUESTION_ATTEMPTS = "/DeleteAttemptScore";
export const ACTIVATE_DEACTIVATE_QUESTION_ATTEMPTS = "/ActivateDeactivateAttemptScore";

// GPA
export const GET_GPA = "/GetGPA";
export const POST_GPA = "/AddGPA";
export const UPDATE_GPA = "/UpdateGPA";
export const DELETE_GPA = "/DeleteGPA";
export const ACTIVATE_DEACTIVATE_GPA = "/ActivateDeactivateGPA";

// User Type
export const GET_USERTYPE = "/GetUserType";
// export const POST_GPA = "/AddGPA";
// export const UPDATE_GPA = "/UpdateGPA";
// export const DELETE_GPA = "/DeleteGPA";
// export const ACTIVATE_DEACTIVATE_GPA = "/ActivateDeactivateGPA";

// User Type
export const GET_MANAGE_SCORE = "/GetManageScores";
export const POST_SCORE = "/AddScore";
export const UPDATE_SCORE = "/UpdateScore";
export const DELETE_SCORE = "/DeleteScore"; 
// export const ACTIVATE_DEACTIVATE_GPA = "/ActivateDeactivateGPA";

// Document
export const GET_DOCUMENT = "/GetDocument";

// Crawl
export const GET_CRAWL = "/GetCrawl";
export const ADD_CRAWL = "/AddCrawl";
export const UPDATE_CRAWL = "/UpdateCrawl";
export const DELETE_CRAWL = "/DeleteCrawl";
export const ACTIVATE_DEACTIVATE_CRAWL = "/ActivateDeactivateCrawl";

// News
export const GET_NEWS = "/GetNews";
export const ADD_NEWS = "/AddNews";
export const UPDATE_NEWS = "/UpdateNews";
export const DELETE_NEWS = "/DeleteNews";
export const ACTIVATE_DEACTIVATE_NEWS = "/ActivateDeactivateNews";

export const GET_NEWS_DATA = "/GetNewsData";
export const ADD_NEWS_DATA = "/AddNewsData";
export const UPDATE_NEWS_DATA = "/UpdateNewsData";
export const DELETE_NEWS_DATA = "/DeleteNewsData";
export const ACTIVATE_DEACTIVATE_NEWS_DATA = "/ActivateDeactivateNewsData";

// Subscription Plan
export const GET_SUBSCRIPTION_PLANS = "/GetSubscriptionPlans";
export const ADD_SUBSCRIPTION_PLAN = "/AddSubscriptionPlan";
export const UPDATE_SUBSCRIPTION_PLAN = "/UpdateSubscriptionPlan";
export const DELETE_SUBSCRIPTION_PLAN = "/DeleteSubscriptionPlans";
export const ACTIVATE_DEACTIVATE_SUBSCRIPTION_PLAN = "/ActivateDeactivateSubscriptionPlan";
export const GET_SUBSCRIPTION_PLAN_BY_ID = "/GetSubscriptionPlanById";
export const GET_SUBSCRIPTION_PLAN_FEATURES = "/GetSubscriptionPlanFeatures";
export const GET_SUBSCRIPTION_PLAN_TAGS = "/GetSubscriptionPlanTags";

// Subscription Plan Module
export const GET_SUBSCRIPTION_PLAN_MODULES = "/GetSubscriptionPlanModules";
export const ADD_SUBSCRIPTION_PLAN_MODULE = "/AddSubscriptionPlanModule";
export const UPDATE_SUBSCRIPTION_PLAN_MODULE = "/UpdateSubscriptionPlanModule";
export const DELETE_SUBSCRIPTION_PLAN_MODULE = "/DeleteSubscriptionPlanModules";
export const ACTIVATE_DEACTIVATE_SUBSCRIPTION_PLAN_MODULE = "/ActivateDeactivateSubscriptionPlanModule";

// Coupon
export const GET_COUPONS = "/GetCoupons";
export const ADD_COUPON = "/AddCoupon";
export const UPDATE_COUPON = "/UpdateCoupon";
export const DELETE_COUPON = "/DeleteCoupon";
export const ACTIVATE_DEACTIVATE_COUPON = "/ActivateDeactivateCoupon";
export const GET_COUPON_BY_ID = "/GetCouponById";

// User Payments
export const GET_USER_WITH_TOTAL_PAYMENT = "/GetUserWithTotalPayment";
export const GET_USER_PAYMENT_HISTORY = "/GetUserPaymentHistory";
// export const UPDATE_CHAT_FEEDBACK_STATUS = "/UpdateChatFeedbackStatus";

// Law Report
export const GET_LAW_REPORT = "/GetLawReport";
export const GET_LAW_STATUS = "/GetCommonLabelByType";
export const GET_ARTICLE_STATUS = "/GetCommonLabelByType";
export const GET_INSTRUMENT_TYPE = "/GetCommonLabelByType";
export const UPDATE_JSON_FIELD = "/UpdateJsonField";
export const UPDATE_JSON_STATUS = "/UpdateJsonStatus";

// Legal Rank
export const GET_LEGAL_RANK = "/GetLegalRank";
export const ADD_LEGAL_RANK = "/AddLegalRank";
export const UPDATE_LEGAL_RANK = "/UpdateLegalRank";
export const DELETE_LEGAL_RANK = "/DeleteLegalRank";
export const ACTIVATE_DEACTIVATE_LEGAL_RANK = "/ActivateDeactivateLegalRank";

// Article Action Report
export const GET_ARTICLE_ACTION_REPORT = "/GetArticleActionReports";
export const GET_LAW_DOCUMENTS = "/GetLawDocuments";

// Article Action
export const GET_ARTICLE_ACTION = "/GetArticleAction";
export const DELETE_ARTICLE_ACTION = "/DeleteArticleAction";

// Contact Support
export const GET_CONTACT_SUPPORT_LIST = "/GetContacts";